import { render, staticRenderFns } from "./EditarFuncionarioPreContratracaoDocumentos.vue?vue&type=template&id=215fd188&scoped=true"
import script from "./EditarFuncionarioPreContratracaoDocumentos.vue?vue&type=script&lang=js"
export * from "./EditarFuncionarioPreContratracaoDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215fd188",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VCol,VSelect,VTextField})
